import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type KeyFeaturesClasses = 'container' | 'description' | 'title' | 'showHideLink' | 'descriptionContainer';

const keyFeaturesStyles = makeStyles<ISpcTheme, KeyFeaturesClasses>(
  theme => ({
    container: {
      paddingBottom: 20,
    },
    title: {
      fontFamily: theme.typography.fontFamily2,
      paddingBottom: 5,
      fontWeight: 'bold',
    },
    description: {
      color: theme.palette.text.primary,
      display: 'block',
    },
    showHideLink: {
      color: theme.palette.secondary.main,
      textDecoration: 'underline',
    },
    descriptionContainer: {
      display: 'flex',
    },
  }),
  { name: 'Customise_KeyFeatures' },
);

export default keyFeaturesStyles;
